module.exports = __webpack_public_path__ + "static/media/Rectangle 9 (5).07608bd7.png";